import { useGLTF, useAnimations } from '@react-three/drei';
import { useLoader, useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import { ObjectLoader, TextureLoader, MeshStandardMaterial, Vector2, LoopRepeat } from 'three';
import { d as defineSrc } from './index-CAxCDj_E.esm.js';
import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import 'clsx';
import './common-DBpCdW70.esm.js';

const Interest = () => {
  const ref = useRef();
  const {
    scene,
    animations
  } = useGLTF(defineSrc('interest.glb'));
  const lights = useLoader(ObjectLoader, defineSrc('interest-light.json'));
  const wiseLogo = useLoader(TextureLoader, defineSrc('file-interest-2.webp'));
  scene.traverse(child => {
    if (child.name.startsWith('coin') && child.isMesh) {
      child.material.map.flipY = true;
      child.material.map.repeat.set(0.25, 0.25);
      child.material.map.offset.set(0.85, -0.03);
      child.material.map.needsUpdate = true;
      child.material = new MeshStandardMaterial({
        map: child.material.map,
        normalMap: wiseLogo,
        normalScale: new Vector2(1.3, 1.3)
      });
    }
  });
  const {
    mixer,
    clips
  } = useAnimations(animations, ref);
  useFrame(() => {
    mixer.clipAction(clips[0]).play().setLoop(LoopRepeat, Infinity);
  });
  return /*#__PURE__*/jsxs(Fragment, {
    children: [/*#__PURE__*/jsx("primitive", {
      ref: ref,
      position: [0, -1, 0],
      scale: 1.45,
      object: scene
    }), /*#__PURE__*/jsx("primitive", {
      object: lights
    })]
  });
};

export { Interest as default };
//# sourceMappingURL=Interest-CgYb6-wb.esm.js.map
